import { api } from '../api/http'

export type DonationCredit = {
  coins: number
  delta: number
  granted: number
}

let enabled: boolean | null = null
let inflight: Promise<boolean> | null = null

/** True when the server has PayPal credentials for coin packs. */
export function paypalDonationsEnabled(): Promise<boolean> {
  if (enabled !== null) return Promise.resolve(enabled)
  if (!inflight) {
    inflight = api<{ enabled?: boolean }>('/economy/donations', { quiet: true })
      .then((body) => {
        enabled = body.enabled === true
        return enabled
      })
      .catch(() => {
        enabled = false
        return false
      })
  }
  return inflight
}

export function startDonation(token: string, tierId: string): Promise<{ approveUrl: string }> {
  return api('/economy/donate', {
    method: 'POST',
    token,
    body: JSON.stringify({ tierId }),
  })
}

export function captureDonation(token: string, orderId: string): Promise<DonationCredit> {
  return api('/economy/donate/capture', {
    method: 'POST',
    token,
    body: JSON.stringify({ orderId }),
  })
}
